import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-white" data-id="element-156" data-mp="9luzmm7107tq">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-157" data-mp="4mi47d239sfj">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-158" data-mp="1297ba1bnev89">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/60 bg-gold/10 text-navy font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-159" data-mp="sarsqmqosuad">
            🤼 Wrestling Coach Ready
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-navy" data-id="element-160" data-mp="3d2torapbqmf2">
            Solve an Entire Year of Wrestling Practices in Just{' '}
            <span className="text-gold-solid" data-id="element-161" data-mp="3j9ai9gc8yw6q">5 MINUTES</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-[320px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-162" data-mp="3o73q0dt77y94">
          <img src="https://cdn.magicpatterns.com/uploads/5ZnjGNNtZ152xLoEYbQhLD/Diseno_sin_titulo_(65).png" alt="Wrestling Coach Ready — complete 6-volume coaching system with 150 ready-to-coach sessions and 5 professional bonus guides" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-163" data-mp="30ggelik2qqht" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-164" data-mp="2hincgih9yklh">
          <p className="text-sm sm:text-lg md:text-xl text-slate leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-165" data-mp="s2te9nr9cdqs">
            The Complete Wrestling Coaching System — 150 ready-to-coach sessions, 6 complete
            volumes, progressive training plans and athlete development tools. Structured
            practices, technical progressions, situational wrestling, competition
            preparation, conditioning, match-intelligence tools and 5 professional bonus
            guides — ready to open, coach and use on the mat.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-166" data-mp="15zzupboie0cu">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-167" data-mp="111eql164ywj4">
              🟡 GET THE COMPLETE WRESTLING COACHING SYSTEM NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-azure-dark" data-id="element-168" data-mp="3hpsgzbzpc357">
            <div className="flex items-center gap-1.5" data-id="element-169" data-mp="1x783jjm4pjs0">
              <CheckCircle size={14} className="text-success" data-id="element-170" data-mp="21a4ohgz55rz4" />
              <span data-id="element-171" data-mp="269zi3saawvnv">150 Ready-to-Coach Sessions</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-172" data-mp="268og9y0f1xze">
              <CheckCircle size={14} className="text-success" data-id="element-173" data-mp="2b0ze8vblj9pb" />
              <span data-id="element-174" data-mp="2b2k6geafugk0">6 Complete Volumes</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-175" data-mp="2fzaov89pto8l">
              <CheckCircle size={14} className="text-success" data-id="element-176" data-mp="2kyndnyk5d5dt" />
              <span data-id="element-177" data-mp="2l100ap0uo3x7">5 Bonus Guides FREE</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-178" data-mp="2p1jv3lxyavg6">
              <CheckCircle size={14} className="text-success" data-id="element-179" data-mp="2tzle66vdmurn" />
              <span data-id="element-180" data-mp="2tysiq21vbrot">Beginner to Advanced</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-181" data-mp="un9bbrw7qrh9">
              <CheckCircle size={14} className="text-success" data-id="element-182" data-mp="uou5hgem88el" />
              <span data-id="element-183" data-mp="zmc6mkme5jc1">Instant Digital Access</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}